import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import React, { useRef, useState } from 'react';
import { fetchdata } from './../reduxactions/organizationactions/OrgDonationsActions';
import { useNavigate } from 'react-router-dom';
import { LoginService } from "../services/LoginService";
import { Toast } from 'primereact/toast';
import { GFNButton } from '../ui';
import { Panel } from 'primereact/panel';

const OrganizationDonations = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchdata(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataAsync();
    }, [dispatch]);
    const data = useSelector((state: RootState) => state.orgdon.data);
    const toast = useRef<any>(null);
    //To open chat
    const donarchat = (rowData: any) => {
        const url = `/ochat/${rowData.donationID}`;
        console.log('Row ID:', rowData.donationID);

        // Use navigate to navigate to the URL
        navigate(url);
    };
    //To open chat
    const thanks = async (rowData: any) => {
        try {
            const payload = { userid: uid, did: rowData.donationID };
            const apiname = "/ws_an_invoice.php";
            const response = await LoginService.getData(apiname, payload);
            if (toast.current) {
                if (response === 'Thank You letter send SuccessfullyUpdated successfully') {
                    toast.current.show({ severity: 'success', detail: response, life: 3000 });
                    //setExpesesadd(false);
                } else {
                    toast.current.show({ severity: 'error', detail: response, life: 3000 });
                    //setExpesesadd(false);
                }
            }
            // dispatch(fetchdatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // const url = `/ochat/${rowData.donationID}`;
        console.log('Row ID:', rowData.donationID);

        // Use navigate to navigate to the URL
        // navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-donations.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div>
            <div className="admin-layout-container">
                <div className="row">
                    <div className="main-content">
                        <div className="content-wrapper">
                            <section className="app-page-header">
                                <div>
                                    <h1 className="app-page-title">Donations</h1>
                                </div>
                                <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                    Help for this Page
                                    <i className="pi pi-question-circle"></i>
                                </a>
                            </section>
                            <Panel>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="card card-primary">
                                            <div className="card flex flex-wrap justify-content-end my-2">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search ml-2" />
                                                    <InputText
                                                        className="app-search-input"
                                                        value={globalFilter}
                                                        onChange={(e) => setGlobalFilter(e.target.value)}
                                                        placeholder="Global Search"
                                                    />
                                                </span>
                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="firstname" sortable header="Donor Name"></Column>
                                                <Column field="CreateDate" sortable header="Date"></Column>
                                                <Column field="Amount" sortable header="Amount "></Column>
                                                <Column field="donationStatus" sortable header="Status"></Column>
                                                <Column header="Operation" body={(rowData, { rowIndex }) => (
                                                    <>
                                                        {/* <Button className='mr-1' data-testid={`like-btn-${rowIndex}`} severity="info" tooltip="Thanks" icon="pi pi-thumbs-up" rounded outlined onClick={() => thanks(rowData)} />
                                                        <Button className='mr-1' data-testid={`comment-btn-${rowIndex}`} severity="info" tooltip="Chat" icon="pi pi-comments" rounded outlined onClick={() => donarchat(rowData)} /> */}
                                                        <GFNButton data-testid={`like-btn-${rowIndex}`} buttonType="secondary" className='mr-3' tooltip="Thanks" icon="pi pi-thumbs-up" rounded onClick={() => thanks(rowData)} />
                                                        <GFNButton data-testid={`comment-btn-${rowIndex}`} buttonType="secondary" tooltip="Chat" icon="pi pi-comments" rounded onClick={() => donarchat(rowData)} />
                                                    </>
                                                )} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                        </div>
                    </div>
                </div>
                <Toast ref={toast} >

                </Toast>
            </div>
        </div>

    )

}

export default OrganizationDonations


